import ClassCChecks from './ClassCChecks';

export default ClassCChecks;